function getTableFromHTML(html) {
  const table = document.createElement("table")
  table.innerHTML = html
  return table
}

export default getTableFromHTML
